import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './features/common/components/home/home.component';
import { PrivacyPolicyComponent } from './features/common/components/privacypolicy/privacypolicy.component';
import { FaqComponent } from './features/common/components/faq/faq.component';
import { SecurityPolicyComponent } from './features/common/components/securitypolicy/securitypolicy.component';
import { ContactComponent } from './features/common/components/contact/contact.component';
import { TermsAndConditionsComponent } from './features/common/components/termsandconditions/termsandconditions.component';
import { WebAccessibilityComponent } from './features/common/components/webaccessibility/webaccessibility.component';
import { HowTosComponent } from './features/common/components/howtos/howtos.component';
import { RegisterComponent } from './features/common/components/register/register.component';
import { CreditCardComponent } from './features/common/components/creditcard/creditcard.component';
import { CreditCardSuccessComponent } from '../app/features/common/components/creditcard/creditcard-success/creditcard-success.component';
import { CreditCardCancelComponent } from '../app/features/common/components/creditcard/creditcard-cancel/creditcard-cancel.component';
import { NcpFAQComponent } from './features/common/components/faq/ncp-faq/ncp-faq.component';
import { NCPCreditCardSubmitCommonComponent } from './features/ncp/components/creditcard/payment/ncpcredit-card-common/ncpcredit-card-submit-common/ncpcredit-card-submit-common.component';

const routes: Routes = [
  { path: 'home', component: HomeComponent },
  {
    path: 'employer',
    loadChildren: () =>
      import('./features/employer/employer.module').then(
        (m) => m.EmployerModule
      ),
  },
  {
    path: 'ncp',
    loadChildren: () =>
      import('./features/ncp/ncp.module').then((m) => m.NcpModule),
  },
  { path: 'register', component: RegisterComponent },
  
  { path: 'creditcard', component: CreditCardComponent },
  { path: 'creditcardSuccess', component: CreditCardSuccessComponent },
  { path: 'creditcardCancelled', component: CreditCardCancelComponent },
  { path: 'payment', component: NCPCreditCardSubmitCommonComponent},

  { path: 'privacypolicy', component: PrivacyPolicyComponent },
  { path: 'securitypolicy', component: SecurityPolicyComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'demo', component: HowTosComponent },
  { path: 'termsandconditions', component: TermsAndConditionsComponent },
  { path: 'webaccessibility', component: WebAccessibilityComponent },
  { path: 'faq', component: FaqComponent },
  { path: 'ncpFAQ', component: NcpFAQComponent },
  { path: '', redirectTo: 'home', pathMatch: 'full' },

  { 
    path: '', 
    redirectTo: '/home', 
    pathMatch: 'full' 
  },

  { 
    path: '**', 
    redirectTo: '/home' 
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
